module.exports = __webpack_public_path__ + "img/calcEliminatorias.445c7076.jpg";